/** Dispatched when a workout session is successfully finished so home/start screens refresh. */
export const WORKOUT_FINISHED_EVENT = 'tt:workout-finished'

export function notifyWorkoutFinished(): void {
  window.dispatchEvent(new Event(WORKOUT_FINISHED_EVENT))
}
